import React,{Component} from "react";


class Login_form extends React.Component{

  constructor() {
    super();
    this.state = {
        mobile: '',
    };
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit = (e) => {
    e.preventDefault();
    console.log(this.state);
  }

    render(){
      const {mobile} = this.state;
        return(
            <div>
                 <form method="post" id="login-form">
                   <div className="utf-no-border">
                     <input type="text" name="emailaddress" id="emailaddress" placeholder="Email Address" onChange={this.loginformData} required/>
                   </div>
                   <div className="utf-no-border">
                     <input type="password" name="password" id="password" placeholder="Password" onChange={this.loginformData} required/>
                   </div>
                  <div className="checkbox margin-top-0">
                	<input type="checkbox" id="two-step" onChange={this.loginformData} />
                	<label htmlFor="two-step"><span className="checkbox-icon"></span> Remember Me</label>
                  </div>
                   <a href="forgot_password.html" className="forgot-password">Forgot Password?</a>
                   <button className="button full-width utf-button-sliding-icon ripple-effect" type="submit" form="login-form">Log In <i className="icon-feather-chevrons-right"></i></button>
                 </form>

                 <div className="utf-social-login-separator-item"><span>or</span></div>
                 <div className="utf-social-login-buttons-block">
                   <button className="facebook-login ripple-effect"><i className="icon-brand-facebook-f"></i> Facebook</button>
                   <button className="google-login ripple-effect"><i className="icon-brand-google-plus-g"></i> Google+</button>
                   <button className="twitter-login ripple-effect"><i className="icon-brand-twitter"></i> Twitter</button>
                 </div>
            </div>
        )
    }
}


export default Login_form;